
import React, { useState, useEffect } from 'react'
import Swal from "sweetalert2";
import Axios from 'axios';
import { API_BASE_URL, INSERT_UNIT } from '../../../Config';
import SpinLoader from '../../../feature-module/loader/SpinLoader';

const AddUnit = () => {

    const [userDataSession, setUserDataSession] = useState([]);

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);

        } else {
            console.log("User data not found in sessionStorage");
        }
    }, []);


    const [formData, setFormData] = useState({
        OrgId: userDataSession.OrgId,
        Name: "",
        ConversionFactor: "",
        IsDefault: 1,
        IsActive: 1,
        CreatedBy: userDataSession.UserId,
        Code: "",
    });

    const [submitBtnLoading, setSubmitBtnLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleCancel = () => {
        setFormData({
                Name: "",
                Description: "",
                Code: "",
                ConversionFactor: "",
            });
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        setSubmitBtnLoading(true);

        let updatedFormData = { ...formData };
        updatedFormData.CreatedBy = userDataSession.UserId;
        updatedFormData.OrgId = userDataSession.OrgId;
        // updatedFormData.ConversionFactor == null ? "NULL" : formData.ConversionFactor;

        console.log(updatedFormData, 'ffffff');

        Axios.post(`${API_BASE_URL}${INSERT_UNIT}`, updatedFormData)
            .then(response => {
                console.log(response.data, 'rrrrrrrr');

                if (response.data.ResultData[0]['Status'] == 'Success') {
                    setSubmitBtnLoading(false);

                    // Show success message
                    Swal.fire({
                        title: `Unit added Successfully.`,
                        icon: "success",
                    }).then((result) => {
                        // Reload the page after the user acknowledges the success message
                        if (result.isConfirmed || result.isDismissed) {
                            window.location.reload();
                        }
                    });
                } else {
                    setSubmitBtnLoading(false);

                    Swal.fire({
                        title: "Error",
                        text: "Failed to Request Submit.",
                        icon: "error",
                    });
                }
            })

            .catch(error => {
                setSubmitBtnLoading(false);
                // Handle error
                console.error('Error adding category:', error);
            });
    };

    return (
        <div>
            {/* Add Unit */}
            {submitBtnLoading&&(<SpinLoader/>)}
            <div
                className="offcanvas offcanvas-end"
                tabIndex={-1}
                id="offcanvasRightUnitAdd"
                aria-labelledby="offcanvasRightLabel"
                style={{ minWidth: '400px' }}
            >
                <div className="offcanvas-header">
                    <h4 id="offcanvasRightLabel">Add Unit</h4>
                    <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    />
                </div> <hr/>
                <div className="offcanvas-body">
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Name<span className="fw-bold text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Name'
                                name="Name"
                                value={formData.Name || ''}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Code<span className="fw-bold text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Code'
                                name="Code"
                                value={formData.Code || ''}
                                onChange={handleChange}
                                maxLength={5}
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Conversion Factor</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder='Enter conversion factor'
                                name="ConversionFactor"
                                value={formData.ConversionFactor}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="modal-footer-btn">
                            <button
                                type="button"
                                className="btn btn-cancel me-2"
                                data-bs-dismiss="offcanvas"
                                aria-label="Close"
                                onClick={handleCancel}
                                 disabled={submitBtnLoading}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-submit"
                                 disabled={submitBtnLoading}
                            >
                                {submitBtnLoading ? 'Submitting..' : 'Save Changes'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {/* /Add Unit */}
        </div>
    )
}

export default AddUnit
